import axios from '@/lib/axios'

/**
 * Generic GET request with optional query params
 * @param {string} url - API endpoint
 * @param {object} [params] - Query parameters (optional)
 */
export async function getData<T = unknown>(url: string, params?: object): Promise<T> {
  const response = await axios.get<{ data: T }>(url, { params })
  return response.data.data
}

/**
 * Generic POST request
 * @param {string} url - API endpoint
 * @param {object} data - Request body
 */
export async function postData<T = unknown>(url: string, data: object): Promise<T> {
  const response = await axios.post<{ data: T }>(url, data)
  return response.data.data
}

/**
 * Generic post as multipart/form-data
 * @param {string} url - API endpoint
 * @param {object} data - Posting data as multipart/form-data
 */
export async function postForm<T = unknown>(url: string, data: object): Promise<T> {
  const response = await axios.postForm<{ data: T }>(url, data)
  return response.data.data
}

/**
 * Generic PATCH request (for updating data)
 * @param {string} url - API endpoint
 * @param {object} data - Request body
 */
export async function patchData<T = unknown>(url: string, data: object): Promise<T> {
  const response = await axios.patch<{ data: T }>(url, data)
  return response.data.data
}

/**
 * Generic DELETE request
 * @param {string} url - API endpoint
 */
export async function deleteData<T = unknown>(url: string): Promise<T> {
  const response = await axios.delete<{ data: T }>(url)
  return response.data.data
}
